import React, { Fragment } from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataCurrentValue } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function AdditionalMeasureValues(props: IElementDataCurrentValue) {
    const { additionalMeasureValues, isReportMetric, settings } = props;
    const fieldKey: ElementMetadataFieldName = 'current_value';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || !isReportMetric || !additionalMeasureValues?.length) return null;

    return (
        <Fragment>
            {additionalMeasureValues.map((measure, index) => (
                <ElementDataRow order={fieldMetadataOrder} key={index}>
                    <ElementDataRowLabel>{measure.label}</ElementDataRowLabel>
                    <ElementDataRowValue>{measure.value}</ElementDataRowValue>
                </ElementDataRow>
            ))}
        </Fragment>
    );
}
